class FormJobPostsView extends BaseForm  {
    constructor(options) {
        super(options);

        this.fields = [
            {name: 'enabled[]', required: false}
        ];
    }

    formSuccessHandler(formScope, data) {
		this.$el.addClass('success');

		setTimeout(()=>{
			this.$el.removeClass('success');
		}, 5000);

		this.doTracking();

		if(this.form.$btn){
			this.form.$btn.removeClass('loading').addClass('loading-complete');
		}

        $.ajax(this.$el.attr('data-refreshCache'),{
            type: 'GET'
        });
    }
}